export enum GuestAppendState {
	LANDING = "LANDING",
	TEAM_SETUP = "TEAM_SETUP",
	COUNTDOWN = "COUNTDOWN",
	WAITING = "WAITING",
	GAME_START = "GAME_START",
	EXPIRED = "EXPIRED",
}
